// src/services/applePayService.ts

import axios from 'axios';
import { ApplePayMerchantSession } from '../utils/types'; // Adjust the import path as needed

export const validateMerchant = async (
  validationURL: string,
  rockmanId: string,
  slug: string
): Promise<ApplePayMerchantSession> => {
  const response = await axios.post<ApplePayMerchantSession>(
    '/api/v1/frontend/ap-validate',
    {
      validationURL,
      rockmanId,
      slug,
      bankId: 4
    },
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
  return response.data;
};

export const processPayment = async (
  payment: ApplePayJS.ApplePayPayment,
  slug: string,
  locale: string,
  rockmanId: string
): Promise<any> => {
  const response = await axios.post(
    '/api/v1/frontend/ap-payment',
    {
      ...payment,
      rockmanId,
      slug,
      bankId: 4, // Celeris Pay
      locale,
      shippingContact: payment.shippingContact,
      token: payment.token
    },
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
  return response.data;
};
